module.exports = __webpack_public_path__ + "img/Patent_3.b105ab86.jpg";